<template>
  <div>
    <el-button class="ms-1" type="success" size="small" :title="$i18n.t('data_versions')" @click="openVersionModal">
      <i class="material-icons md-18">manage_history</i>
    </el-button>
    <modal :id="`version-${this.idForm}`" size="80%" :title="$i18n.t('Form_versions')">
      <list-container v-bind="listParams"></list-container>
    </modal>
  </div>
</template>
<script>
import Modal from '../modal/Modal'
import store from '../../store'
import ListContainer from '../../components/list-new/ListContainer'

import { get } from 'lodash'
import { PANEL_TYPES } from '../layout-manager/gui-editor/options/schema'

/**
 * @class FormDataVersionList
 *
 * @description This component renders the saved dataversions of Forms
 */
export default {
  name: 'FormDataVersionList',
  props: ['idForm', 'idMainTable', 'isBlockchainEnabled', 'showCloneButton', 'showCopyButton', 'showVersionButton'],
  components: {
    Modal,
    ListContainer,
  },
  data() {
    return {
      columns: [
        {
          type: 'number',
          name: 'version',
          label: this.$i18n.t('form_version'),
        },
        {
          type: 'text',
          name: 'createDate',
          label: this.$i18n.t('create_date'),
        },
        {
          type: 'text',
          name: 'userCreate',
          label: this.$i18n.t('user_create'),
        },
      ],
    }
  },
  computed: {
    buttons() {
      const buttons = [
        { selector: 'data-version', enabled: this.showVersionButton },
        { selector: 'clone', enabled: this.showCloneButton },
        { selector: 'copy', enabled: this.showCopyButton },
      ]
      return buttons
        .filter((button) => button.enabled)
        .map((button) => {
          return { selector: button.selector }
        })
    },
    listParams() {
      return {
        mongoList: {
          displayFooterButtons: false,
          buttons: this.buttons,
          collection: 'FormDataVersion',
          urlParams: {},
          columns: this.columns,
        },
        hiddenSearchData: {
          where: [
            { key: 'idForm', value: this.idForm },
            { key: 'idMaintable', value: this.idMainTable },
          ],
        },
        extraOptions: {
          showSavedFilter: false,
          showLockColumn: false,
          showSelectionColumn: true,
          showColumnSelector: true,
          showResetButton: false,
          exportSettings: {
            showExportButton: false,
            exportTypes: {},
          },
          availableViews: {
            gridView: true,
            cardView: false,
            detailView: false,
            defaultView: 'gridView',
          },
          showActionButtons: true,
        },
        isVersionList: true,
        componentType: PANEL_TYPES.FORM_DATA_VERSION,
      }
    },
  },
  methods: {
    openVersionModal() {
      store.commit('TOGGLE_MODAL', {
        id: `version-${this.idForm}`,
        isOpen: true,
      })
    },
    async getFormColumns() {
      await this.$client
        .execute({
          operationId: 'FormDataVersions_getColumns',
          method: 'get',
          parameters: {
            id: this.idForm,
          },
        })
        .then((response) => {
          const formColumns = get(response, 'body', [])
          this.columns = this.columns.concat(formColumns)
          if (this.isBlockchainEnabled) {
            this.columns.push({
              type: 'text',
              name: 'blockChainHash',
              label: this.$i18n.t('blockchain_hash'),
            })
          }
        })
    },
  },
  created() {
    this.getFormColumns()
  },
}
</script>
